import { render, staticRenderFns } from "./DrinkVisu.vue?vue&type=template&id=563446b8&"
import script from "./DrinkVisu.vue?vue&type=script&lang=js&"
export * from "./DrinkVisu.vue?vue&type=script&lang=js&"
import style0 from "./DrinkVisu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports